import Resource from './Resource';

export default class Recent extends Resource{
	constructor( options = {} ){
		let {
			query = {}
		} = options;

		let o = { 
			route: "recents",
			query: query
		};
		super(o);
		return this;
	}

	get(){
		return this.request();
	}
}
